import { EnvironmentService } from './environment.service';

export const webappClientHeaders = {
  'X-App-WebappClient': EnvironmentService.getVariable('WEBAPP_CLIENT'),
};
